import { Tooltip, Box, Typography, Paper, useTheme } from "@mui/material";
import { ChatButton } from "Common/Components";
import { INFO_TYPE } from "Common/Constants";
import { useMatchDownMd } from "Common/Hooks";
import { ExpandMoreOutlined } from "Icons/Icons";
import { CUSTOM_ELEVATIONS } from "Theme/Shadows";

interface IInfoHeader {
  infoType: string;
  isDivisionLoading: boolean;
  isConversationLoading: boolean;
  divisionScope: string;
  setIsCollapsedReference: (value: React.SetStateAction<boolean>) => void;
  setReferenceDrawer: (value: React.SetStateAction<boolean>) => void;
}

export const InfoHeader = ({
  infoType,
  isDivisionLoading,
  isConversationLoading,
  divisionScope,
  setIsCollapsedReference,
  setReferenceDrawer,
}: IInfoHeader) => {
  const { matchDownMd } = useMatchDownMd();
  const theme = useTheme();

  const buttonConfig = matchDownMd
    ? { backgroundColor: theme.palette.grey[200], onClick: () => setReferenceDrawer(true) }
    : { backgroundColor: "transparent", onClick: () => setIsCollapsedReference((prev) => !prev) };

  return (
    <Paper
      sx={{
        px: 3,
        py: 1,
        height: 60,
        display: "flex",
        flexDirection: "row",
        justifyContent: "space-between",
        alignItems: "center",
        boxShadow: CUSTOM_ELEVATIONS.menu,
        position: "relative",
        zIndex: 1000,
      }}
    >
      <Tooltip title={infoType === INFO_TYPE.DOCUMENT ? "Documents" : "Service Intelligence"} arrow>
        <Box>
          <Typography variant="body1" sx={{ pl: 0, fontWeight: "fontWeightSemiBold" }}>
            {infoType === INFO_TYPE.DOCUMENT ? "Documents" : "Service Intelligence"}
          </Typography>
          <Typography variant="caption">
            {(isDivisionLoading || isConversationLoading) && !divisionScope
              ? "Loading...."
              : divisionScope || "No brands linked."}
          </Typography>
        </Box>
      </Tooltip>
      {infoType === INFO_TYPE.DOCUMENT && (
        <ChatButton
          tooltipTitle="View related references"
          hasBackground
          backgroundColor={buttonConfig.backgroundColor}
          Icon={ExpandMoreOutlined}
          onClick={buttonConfig.onClick}
        />
      )}
    </Paper>
  );
};
